<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        :disabled="dialog"
        v-on="on"
      >
        <v-icon left>
          add
        </v-icon>
        Create Category
      </v-btn>
    </template>
    <v-card>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="onSubmitForm"
      >
        <v-card-title>
          <span class="headline">Create Category</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="title"
                  :rules="titleRules"
                  label="Title"
                  placeholder="Enter category title"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="slug"
                  :rules="slugRules"
                  label="Slug"
                  placeholder="Enter category slug"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            flat
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="isSubmitting"
            color="success"
            flat
            type="submit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data: () => ({
    dialog: false,
    valid: false,
    isSubmitting: false,
    title: '',
    titleRules: [
      value => !!value || 'Required',
      value => (value && value.length <= 70) || 'Maximum 70 characters',
      value => (value && value.length >= 4) || 'Minimum 4 characters',
    ],
    slug: '',
    slugRules: [
      value => !!value || 'Required',
      value => (value && value.length <= 50) || 'Maximum 50 characters',
      value => (value && value.length >= 4) || 'Minimum 4 characters',
      value => (value && /^[a-z0-9/-]+$/.test(value)) || 'Only lowercase letters, numbers or hypens allowed',
    ],
  }),
  methods: {
    ...mapActions({
      onCreateCategory: 'blogCategories/createCategory',
      getCategories: 'blogCategories/getCategories',
      setDisplay: 'snackbar/setDisplay',
      setMessage: 'snackbar/setMessage'
    }),
    onSubmitForm () {
      if (this.$refs.form.validate()) {
        this.isSubmitting = true
        this.onCreateCategory({
          title: this.title,
          slug: this.slug
        }).then((response) => {
          if (response === 201) {
            this.getCategories(1, 10).then(() => {
              this.dialog = false
              this.isSubmitting = false
              this.title = ''
              this.slug = ''
              this.$refs.form.reset()
              this.setDisplay(true)
              this.setMessage('Category was created')
            })
          }
        })
      }
    }
  }
}
</script>
